import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import { SnackbarProvider } from 'notistack'


import App from './App'
import { theme } from './theme'
import reportWebVitals from './reportWebVitals'
import SnackbarCloseButton from '@components/customized/SnackbarCloseButton'
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
	<ThemeProvider theme={theme}>
		<SnackbarProvider
			maxSnack={5}
			action={(key) => {
				return <SnackbarCloseButton id={key} />
			}}
		>
			<App />
		</SnackbarProvider>
	</ThemeProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
